<div [innerHTML]="htmlHelpText"></div>

<div mat-dialog-actions>
	<span [ngClass]="{ 'action-button': true, 'primary-button': true }" (click)="onClose()">Ok</span>
</div>
